import { render } from "./TerryBucketHat_1_back.vue?vue&type=template&id=38e816e8"
import script from "./TerryBucketHat_1_back.vue?vue&type=script&lang=js"
export * from "./TerryBucketHat_1_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__